import type { ReactNode } from 'react'
import { ArrowLeft } from 'lucide-react'
import { SiteHeader } from '@/components/site-header'
import { SiteFooter } from '@/components/site-footer'

export function ContentPage({
  eyebrow,
  title,
  description,
  wide = false,
  children,
}: {
  eyebrow: string
  title: string
  description: string
  wide?: boolean
  children: ReactNode
}) {
  const container = wide ? 'max-w-7xl' : 'max-w-4xl'

  return (
    <div id="top" className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="border-b border-border/60 grid-bg">
          <div className={`mx-auto ${container} px-4 pt-6 pb-3 md:pt-8 md:pb-4`}>
            <a
              href="/"
              className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to home
            </a>
            <span className="mt-5 block font-mono text-sm text-primary">{eyebrow}</span>
            <h1 className="mt-2 text-balance text-4xl font-bold tracking-tight sm:text-5xl">
              {title}
            </h1>
            <p className="mt-3 max-w-2xl text-pretty text-lg leading-relaxed text-muted-foreground">
              {description}
            </p>
          </div>
        </div>
        <div className={`mx-auto ${container} px-4 pt-3 pb-5 md:pt-4 md:pb-6`}>{children}</div>
      </main>
      <SiteFooter />
    </div>
  )
}

export function Prose({ children }: { children: ReactNode }) {
  return <div className="flex flex-col gap-8">{children}</div>
}

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-2xl font-bold tracking-tight text-foreground">{title}</h2>
      <div className="flex flex-col gap-4 leading-relaxed text-muted-foreground">{children}</div>
    </section>
  )
}
